
import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import BillingSettings from './BillingSettings';
import MembersSettings from './MembersSettings';

interface PortfolioTabContentProps {
  activeTab: string;
  name: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  billingData: {
    activeBusinesses: any[];
    pausedBusinesses: any[];
    managedBudgets: any[];
    availableCredits: number;
    promotionalDiscount: number;
    billingManager: {
      name: string;
      email: string;
      phone: string;
    };
    billingHistory: any[];
  };
  paymentMethods: any[];
  discountCodes: any[];
  totalCharge: number;
  selectedPaymentMethod: string;
  setSelectedPaymentMethod: (id: string) => void;
  handleAddPaymentMethod: () => void;
  handleAddPromoCode: () => void;
  handleMakePrimary: (methodId: string) => void;
  handleChangeBillingManager?: (userId: string) => void;
  formatCurrency: (amount: number) => string;
}

const PortfolioTabContent = ({
  activeTab,
  name,
  handleInputChange,
  billingData,
  paymentMethods,
  discountCodes,
  totalCharge,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  handleAddPaymentMethod,
  handleAddPromoCode,
  handleMakePrimary,
  handleChangeBillingManager,
  formatCurrency
}: PortfolioTabContentProps) => {
  return (
    <>
      <TabsContent value="general" className="space-y-4">
        <div className="space-y-2 py-6">
          <h2 className="text-2xl font-bold tracking-tight">General Settings</h2>
          <p className="text-muted-foreground">
            Update your portfolio name and general settings.
          </p>
        </div>
        <Separator />
        <div className="space-y-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="name">Portfolio Name</Label>
            <Input
              id="name"
              name="name"
              value={name}
              onChange={handleInputChange}
              placeholder="Enter portfolio name"
            />
          </div>
        </div>
      </TabsContent>
      
      <TabsContent value="billing">
        <BillingSettings 
          activeBusinesses={billingData.activeBusinesses}
          pausedBusinesses={billingData.pausedBusinesses}
          managedBudgets={billingData.managedBudgets}
          availableCredits={billingData.availableCredits}
          promotionalDiscount={billingData.promotionalDiscount}
          totalCharge={totalCharge}
          billingManager={billingData.billingManager}
          paymentMethods={paymentMethods}
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          discountCodes={discountCodes}
          billingHistory={billingData.billingHistory}
          handleAddPaymentMethod={handleAddPaymentMethod}
          handleAddPromoCode={handleAddPromoCode}
          handleMakePrimary={handleMakePrimary}
          handleChangeBillingManager={handleChangeBillingManager}
          formatCurrency={formatCurrency}
        />
      </TabsContent>
      
      <TabsContent value="users">
        <MembersSettings source="portfolio" />
      </TabsContent>
    </>
  );
};

export default PortfolioTabContent;
